import { useMediaQuery, useSavePageScrollPosition } from '@patrianna/shared-hooks'
import cx from 'classnames'
import { useContext } from 'react'
import type { ReactNode } from 'react'

import BackButton from 'components/BackButton'
import CloseModalButton from 'dialogs/components/CloseModalButton'

import AnimationOverlayContext from '../AnimatedOverlay/AnimationOverlayContext'

import classes from './styles.module.scss'

type Props = {
  children?: ReactNode
  isBackButtonDesktop?: boolean
  isCloseButton?: boolean
  isCloseButtonDesktop?: boolean
  isHideBackButton?: boolean
  action?: () => void
  combineActions?: boolean
  isCloseAll?: boolean
  classNames?: {
    root?: string
    title?: string
    closeButton?: string
  }
  dataTestId?: string
}

const closeButtonGenerator = (props: Props, isMobile: boolean, callBack: () => void) => {
  if (props.isCloseButtonDesktop && !isMobile) {
    return (
      <CloseModalButton
        closeAll
        className={cx(classes.closeButton, props?.classNames?.closeButton)}
        callBack={callBack}
      />
    )
  }
  if (props.isCloseButton && isMobile) {
    return (
      <CloseModalButton
        closeAll={props?.isCloseAll}
        className={cx(classes.closeButton, props?.classNames?.closeButton)}
        callBack={callBack}
      />
    )
  }

  return null
}

function DialogCaption(props: Props) {
  const isMobile = useMediaQuery('xs')
  const context = useContext(AnimationOverlayContext)

  const preventScrollHandler = useSavePageScrollPosition()
  const closeButtonCallBack = () => {
    preventScrollHandler()
    props.action?.()
  }

  return (
    <div className={cx(classes.root, props.classNames && props.classNames.root && props.classNames.root)}>
      {!props.isHideBackButton && !props.isCloseButton && (isMobile || props.isBackButtonDesktop) ? (
        <BackButton
          handler={() => {
            if (props.combineActions) {
              props.action()
              context.visibilityHandler()
            } else {
              const action = props.action || context.visibilityHandler
              action()
            }
            preventScrollHandler()
          }}
          className={classes.backButton}
        />
      ) : (
        ''
      )}

      <h6
        className={cx(
          'mt-typography-h6',
          classes.title,
          props.classNames && props.classNames.title && props.classNames.title,
        )}
        data-testid={props?.dataTestId || 'dialog-caption-title'}
      >
        {props.children && props.children}
      </h6>
      {closeButtonGenerator(props, isMobile, closeButtonCallBack)}
    </div>
  )
}

export default DialogCaption
